var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center "},[_c('h2',{staticClass:"text-3xl font-bold"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"text-2xl mt-4 mb-10"},[_vm._v(" "+_vm._s(_vm.timestamp)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }